export default "__VITE_ASSET__2625bdde__"